import React from 'react'
import {connect} from 'react-redux'
import {Flex, SVGButton} from '/app/src/component'
import style from './style.css'
import {history} from '/app/src/store';
import UserSelector from '/app/src/model/User/selector'
import UserModel from '/app/src/model/User/model'



import { NotificationSelector } from '/app/src/model/Notification'

class NotificationDisplay extends React.Component {

    constructor(props)
    {
        super(props);

        this._handleClickOutside = this._handleClickOutside.bind(this);
        this._handleNotifyClick = this._handleNotifyClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this._handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this._handleClickOutside);
    }

    _handleClickOutside(e){
        if (this.props.notificationRef && !this.props.notificationRef.contains(e.target)){
            this.props.onClickCloseModal('notificationDisplay');
        }
    }

    _handleSettingsClick(e) {
        history.push({
            pathname: '/user/notifications'
        });
    }

    _handleNotifyClick(e) {
        const dispatch = this.props.dispatch
        dispatch(UserModel.muteNotifications(!this.props.soundNotifyIsOn));
        dispatch(UserModel.killNotifications(!this.props.webNotifyIsOn));
    }

    render() {
        const notifications = this.props.notifications.map((notification, i) => {
            const notificationText = NotificationSelector._toString(notification);
            if(notificationText !== ''){
                return (
                    <li className={style.NotificationListItem} key={i}> {notificationText} </li>
                );
            }else{
                return null;
            }
        });
        return (
            <Flex
                className={style.NotificationContainer}
                w='350px'
                pos='absolute' right='7px' top='56px'
                marginRight='0px !important'
                z='1'
                bg='white'
                column
                >
                    <Flex column>
                        <Flex
                            className={style.NotificationHeader}
                            basis='50px'
                            center>
                                <Flex grow center>
                                    <p className={style.HeaderText}> Notifikationer </p>
                                </Flex>
                                <Flex basis='15%'>
                                    <SVGButton
                                        src='/images/Notifications_Mute.svg'
                                        color='lightgrey'
                                        hover='red'
                                        onClick={this._handleNotifyClick}
                                        active={!this.props.webNotifyIsOn && !this.props.soundNotifyIsOn}
                                        width='50px'
                                    />
                                </Flex>
                                <Flex basis='15%'>
                                    <SVGButton
                                        src='/images/Notifications_Settings_M.svg'
                                        color='lightgrey'
                                        hover='blue'
                                        onClick={this._handleSettingsClick}
                                        width='50px'
                                    />
                                </Flex>
                        </Flex>
                        <Flex
                            className={style.NotificationWrapper}
                            marginRight='0px !important'
                            column
                            overflow='auto'
                            basis='180px'
                            marginBottom='15px'>
                            <ul>
                                {notifications}
                            </ul>
                        </Flex>
                    </Flex>
            </Flex>
        )
    }
}

function mapStateToProps(state) {
    return{
        webNotifyIsOn: UserSelector.webNotifyIsOn(state),
        soundNotifyIsOn: UserSelector.soundNotifyIsOn(state)
    }
}

export default connect(mapStateToProps, null)(NotificationDisplay);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/Header/NotificationDisplay/index.js